export const PRIME_AGENT = "PRIME";